<template>
  <div class="notification-box-modal">
    <div class="mobile-app-banner">
      <div class="close-button" @click="closeBanner()">
        <span class="pp-icon pp-icon-close"></span>
      </div>
      <a :href="banner.app_link" target="_blank">
        <img :src="banner.banner_url">
      </a>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "MobileAppBanner",
  props: ['banner'],
  methods:{
    closeBanner: function (){
      this.$store.commit('app/setShowMobileAppBanner', false);
    }
  },
  computed:{
    ...mapGetters('app', {
      mobile_app_banner: 'getShowMobileAppBanner'
    }),
  }
}
</script>

<style scoped lang="scss">
.mobile-app-banner{
  position: relative;
  .close-button{
    padding: 1rem;
    border-radius: 1rem;
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    position: absolute;
    top: -1rem;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    span{
      font-size: 0.785rem;
    }
  }
}
</style>
